import React, { Fragment } from 'react'
import { AreaChart, CartesianGrid, XAxis, YAxis, Tooltip, Area, ResponsiveContainer } from 'recharts'

function Tick({ payload, x, y, ...props }) {
  // Calculate offsets for the rect and text svgs, in accordance with the string length
  const tickWidth = payload.value.toString().length > 1 ? payload.value.toString().length * 10 : 20
  const tickWidthOffset = payload.value.toString().length > 1 ? payload.value.toString().length * 5 : 0

  return (
    <Fragment>
      <rect
        {...props}
        y={y - 15}
        x={x - 38}
        height="27"
        width={`${tickWidth}`}
        strokeWidth="0"
        stroke="#000"
        fill="#fff"
        rx={6}
        ry={6}
      />
      <text
        {...props}
        x={x - 24 + tickWidthOffset}
        y={y + 3}
        fontSize="12"
        strokeWidth="0"
        stroke="#000"
        fill="##77869e"
      >
        {payload.value}
      </text>
    </Fragment>
  )
}

function ExpenseChart({ data, metadata }) {
  const padDate = (tickItem) => tickItem.toString().padStart(2, '0')
  const spendColor = metadata[0].borderColor
  const earnColor = metadata[1].borderColor

  return (
    <ResponsiveContainer width="95%" height={380}>
      <AreaChart data={data} margin={{ top: 5, right: 0, bottom: 25, left: 0 }}>
        <defs>
          <linearGradient id="spendColor" x1="0" y1="0" x2="0" y2="1">
            <stop offset="5%" stopColor={spendColor} stopOpacity={0.3} />
            <stop offset="95%" stopColor={spendColor} stopOpacity={0} />
          </linearGradient>
          <linearGradient id="earnColor" x1="0" y1="0" x2="0" y2="1">
            <stop offset="5%" stopColor={earnColor} stopOpacity={0.3} />
            <stop offset="95%" stopColor={earnColor} stopOpacity={0} />
          </linearGradient>
        </defs>
        <Area
          type="monotone"
          strokeWidth={3}
          dataKey="spend"
          stroke={spendColor}
          fill="url(#spendColor)"
          activeDot={{ stroke: spendColor, strokeWidth: 3, fill: '#fff' }}
        />
        <Area
          type="monotone"
          strokeWidth={3}
          dataKey="earn"
          stroke={earnColor}
          fill="url(#earnColor)"
          activeDot={{ stroke: earnColor, strokeWidth: 3, fill: '#fff' }}
        />
        <CartesianGrid strokeDasharray="3 3" vertical={false} />
        <XAxis
          dataKey="name"
          axisLine={false}
          tickLine={false}
          tickMargin={20}
          tickFormatter={padDate}
          tick={{ fontSize: 12, fill: '#77869e' }}
        />
        <YAxis
          tick={
            <Tick />
        }
          width={30}
          axisLine={false}
          tickLine={false}
          tickMargin={-25}
        />
        <Tooltip cursor={{ stroke: '#77869e', strokeWidth: 1 }} content={() => {}} />
      </AreaChart>
    </ResponsiveContainer>
  )
}

export default ExpenseChart
